import handleQueryError from '../../../util/Common/Error/Handler/handleQueryError';
import dailyInOutDefaultAPI from '../api';

const getInventoryContainerWithChassisList = async ({ div, yard }) => {
  try {
    const response = await dailyInOutDefaultAPI.get(
      'invt-container-with-chassis',
      {
        params: { div, yard },
      },
    );
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getInventoryContainerWithChassisList;
